import axios from 'axios';

const PRODUCTION_API_URL = 'https://leads-automater-api.nowgray.live';
const LOCAL_API_URL = 'http://localhost:30020';

/**
 * API base URL:
 * - `npm run build` / production → always production backend
 * - `npm start` / development → local backend
 * - Optional override: REACT_APP_API_URL in .env
 */
const getApiUrl = () => {
  const fromEnv = (process.env.REACT_APP_API_URL || '').trim().replace(/\/$/, '');
  if (fromEnv) return fromEnv;

  if (process.env.NODE_ENV === 'production') {
    return PRODUCTION_API_URL;
  }

  return LOCAL_API_URL;
};

const apiUrl = getApiUrl();

const apiClient = axios.create({
  baseURL: apiUrl,
  timeout: 90000,
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export default apiClient;
export { getApiUrl };
